import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ApiTokenService {
  private apiUrl = '/api/v1/generate-api-key';

  constructor(private http: HttpClient) {}

  generateApiToken(): Observable<any> {
    return this.http.post(this.apiUrl, {}, { responseType: 'text' });
  }
}
